import React from "react";
import { useNavigate } from "react-router-dom";

import Modal from "../ui/Modal";

/**
 * Renders children inside Modal; closes by navigating to closeTo (e.g. parent `/leads/` URL).
 * Use as the element of a nested Route, paired with an Outlet on the parent route layout.
 */
export function ModalRoute({ children, closeTo, onClose, dialogClassName, preventClose = false }) {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose?.();
    navigate(closeTo);
  };

  return (
    <Modal onClose={handleClose} dialogClassName={dialogClassName} preventClose={preventClose}>
      {children}
    </Modal>
  );
}
